import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { GooglePhoto } from '../models';

export interface GooglePhotoApi {
    items: GooglePhoto[];
    total_count: number;
}

@Injectable({
    providedIn: 'root'
})
export class GooglePhotoService {
    private _googlePhotoRoute = '/api/google-photos/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    public pageLayoutBeingViewed: any = {};

    constructor(
        private httpClient: HttpClient
    ) { }


    setGooglePhotoToBeViewed(_googlePhoto: any) {
        this.pageLayoutBeingViewed = _googlePhoto;
    }


    getGooglePhotoToBeViewed() {
        return this.pageLayoutBeingViewed;
    }


    get(): Observable<any[]> {
        return this.httpClient.get<any[]>(this._googlePhotoRoute);
    }


    getById(_googlePhotoId: string): Observable<any> {
        return this.httpClient.get<any>(this._googlePhotoRoute + _googlePhotoId);
    }


    getByName(pageLayoutName: string): Observable<GooglePhoto> {
        return this.httpClient.get<GooglePhoto>(this._googlePhotoRoute + 'by-name/' + pageLayoutName);
    }


    delete(_googlePhoto: GooglePhoto): Observable<any> {
        return this.httpClient.delete(this._googlePhotoRoute + _googlePhoto._id, this.headerOptions);
    }
}